export default __webpack_public_path__ + "static/media/hamzaQuote.c8aa1270.png";